var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8235 15.7728L21.8623 20.8116C22.0459 20.9952 22.0459 21.292 21.8623 21.4756L21.4756 21.8623C21.292 22.0459 20.9952 22.0459 20.8116 21.8623L15.7728 16.8235C15.6868 16.7337 15.6361 16.6165 15.6361 16.4915V16.0931C14.1869 17.4289 12.2534 18.2492 10.1246 18.2492C5.63654 18.2492 2 14.6127 2 10.1246C2 5.63654 5.63654 2 10.1246 2C14.6127 2 18.2492 5.63654 18.2492 10.1246C18.2492 12.2534 17.4289 14.1869 16.0892 15.6361H16.4915C16.6165 15.6361 16.7337 15.6829 16.8235 15.7728ZM3.24994 10.1246C3.24994 13.9252 6.32401 16.9993 10.1246 16.9993C13.9252 16.9993 16.9993 13.9252 16.9993 10.1246C16.9993 6.32401 13.9252 3.24994 10.1246 3.24994C6.32401 3.24994 3.24994 6.32401 3.24994 10.1246Z",
    fill: "#454545"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5104_18739",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8235 15.7728L21.8623 20.8116C22.0459 20.9952 22.0459 21.292 21.8623 21.4756L21.4756 21.8623C21.292 22.0459 20.9952 22.0459 20.8116 21.8623L15.7728 16.8235C15.6868 16.7337 15.6361 16.6165 15.6361 16.4915V16.0931C14.1869 17.4289 12.2534 18.2492 10.1246 18.2492C5.63654 18.2492 2 14.6127 2 10.1246C2 5.63654 5.63654 2 10.1246 2C14.6127 2 18.2492 5.63654 18.2492 10.1246C18.2492 12.2534 17.4289 14.1869 16.0892 15.6361H16.4915C16.6165 15.6361 16.7337 15.6829 16.8235 15.7728ZM3.24994 10.1246C3.24994 13.9252 6.32401 16.9993 10.1246 16.9993C13.9252 16.9993 16.9993 13.9252 16.9993 10.1246C16.9993 6.32401 13.9252 3.24994 10.1246 3.24994C6.32401 3.24994 3.24994 6.32401 3.24994 10.1246Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5104_18739)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ae922472d6017feb02631370389075ce.svg";
export { ForwardRef as ReactComponent };